/* eslint-disable camelcase */
import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { PanelState } from 'store/modules/panel_store/types';
import { ProfileState } from 'store/modules/profile_store/types';

const ExpirationAlert = () => {
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  if (!panel.show_expiration_alert) return <div />;

  const alertType = panel.days_to_end < 0 ? 'danger' : 'warning';

  const subscriptionTime = (days_to_end: number) => {
    if (days_to_end < 0) return <strong>expirou</strong>;

    if (days_to_end === 0)
      return (
        <>
          terminará <strong>hoje</strong>
        </>
      );

    return (
      <>
        terminará em
        <strong>
          {' '}
          {days_to_end} {days_to_end > 1 ? 'dias' : 'dia'}
        </strong>
      </>
    );
  };

  return (
    <div className={`card alert alert-${alertType} alert-border-${alertType} shadow mt-2 mb-0`}>
      <div className="card-body text-center text-md-left d-md-flex align-items-center">
        <i className="material-icons warning-icon flex-shrink-1">error_outline</i>
        <h3 className="w-100 mb-2 m-md-0 pl-md-3">
          Sua {profile.in_sample ? 'amostra' : 'assinatura'} {subscriptionTime(panel.days_to_end)}
        </h3>
        <a className="btn btn-lg btn-success flex-shrink-1 text-nowrap" href="/planos">
          Ative sua assinatura
        </a>
      </div>
    </div>
  );
};
export default ExpirationAlert;
